<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Websocket Messages</div>
	</div>
	<p-divider></p-divider>
	<ng-container *ngFor="let message of venueService.venueMessageList.value">
		<app-socket-message [message]="message"></app-socket-message>
	</ng-container>
</div>
